import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import H1 from "@/components/H1";
import P from "@/components/P";
import Select from "@/components/Select";
import SmallButton from "@/components/SmallButton";
import Spacer from "@/components/Spacer";
import songkick from "@/images/songkick.png";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddSongkick() {
  const { t } = useTranslation("onboarding");
  // const songkickResult = AppState.useState(s => s.addAccount.songkick);
  const songkickResult = useAppStore(state => state.addAccount?.songkick);
  const navigate = useNavigate();
  // const apiUrl = AppState.getRawState()?.apiUrl;
  const apiUrl = useAppStore(state => state.apiUrl);

  const getOptions = query =>
    new Promise((resolve, reject) => {
      if (!query) {
        resolve([]);
        return;
      }
      fetch(`${apiUrl}/songkick?s=${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then((result) => {
          resolve(
            result.resultsPage.results.artist.map(artist => ({
              value: JSON.stringify(artist),
              name: artist.displayName,
            })),
          );
        })
        .catch(reject);
    });

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">
        <img width="80" src={songkick} alt="songkick logo" />
        <Spacer />
        {!songkickResult && (
          <>
            <h1 className="text-6xl">{t("onboarding:add-songkick-header")}</h1>
            <Spacer />
            <P>{t("onboarding:add-songkick-desc")}</P>
            <Spacer />
            <div className="relative flex flex-col items-center justify-center w-full">
              <div className="w-full lg:w-1/3">
                <div className="flex flex-row items-start justify-center w-full text-ink-primary">
                  <Select
                    authSearch
                    className="custom-select no-dropdown"
                    debounce={500}
                    onChange={(artist) => {
                      // AppState.update((s) => {
                      //   s.addAccount.songkick = artist;
                      // });

                      useAppStore.getState().setAddAccountSocial("songkick", artist);
                    }}
                    getOptions={getOptions}
                    placeholder={t("onboarding:search-songkick-placeholder")}
                    search
                    customLabel="Songkick Artist Name"
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {!!songkickResult && (
          <>
            <H1>{t("onboarding:selected-songkick-profile")}</H1>
            <Spacer />
            <div className="flex flex-col items-center p-4 px-6 bg-white rounded-lg shadow-lg text-ink-primary">
              <p className="mb-4 font-bold">
                {JSON.parse(songkickResult).displayName}
              </p>
              <SmallButton
                onClick={() => {
                  // AppState.update((s) => {
                  //   s.addAccount.songkick = null;
                  // });

                  // Using the action helper from appStateZustand.js
                  useAppStore.getState().setAddAccountSocial("songkick", null);
                }}
              >
                {t("common:remove")}
              </SmallButton>
            </div>
          </>
        )}
        <Spacer />

        <div className="flex flex-row justify-center w-full lg:w-1/3">
          <AuthPrimaryButton onClick={() => navigate({ to: "/add-account-5" })}>
            {t("common:_done")}
          </AuthPrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default AddSongkick;
